import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2, Send, CheckCircle2, AlertTriangle } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";

export function ContactForm({ psychologistId }) {
  const { t } = useLang();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) return;
    setSending(true);
    try {
      await api.post(`/psychologists/${psychologistId}/contact`, form);
      setSent(true);
      toast.success(t("contact.sent"));
    } catch {
      toast.error(t("contact.error"));
    } finally {
      setSending(false);
    }
  };

  if (sent) {
    return (
      <div className="rounded-xl bg-[#EBF6F0] px-4 py-4 text-sm text-[#1E6B47]" data-testid="contact-form-success">
        <CheckCircle2 className="mb-1.5 h-5 w-5" />
        {t("contact.sent")}
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="profile-contact-form">
      <p className="text-sm text-muted-foreground">{t("contact.desc")}</p>
      <div className="flex items-start gap-2 rounded-lg bg-cream px-3 py-2.5 text-xs text-muted-foreground" data-testid="contact-notice">
        <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0" />
        {t("contact.notice")}
      </div>
      <div>
        <Label>{t("contact.name")}</Label>
        <Input value={form.name} onChange={(e) => set("name", e.target.value)} data-testid="contact-name-input" required />
      </div>
      <div>
        <Label>{t("contact.email")}</Label>
        <Input type="email" value={form.email} onChange={(e) => set("email", e.target.value)} data-testid="contact-email-input" required />
      </div>
      <div>
        <Label>{t("contact.message")}</Label>
        <Textarea rows={4} value={form.message} onChange={(e) => set("message", e.target.value)} data-testid="contact-message-input" required />
      </div>
      <Button type="submit" disabled={sending} className="w-full rounded-full bg-terracotta hover:bg-terracotta-hover" data-testid="contact-send-btn">
        {sending ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />{t("contact.sending")}</> : <><Send className="mr-2 h-4 w-4" />{t("contact.send")}</>}
      </Button>
    </form>
  );
}
